<template>
    <div>
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    SEO &amp; PPC
                </div>
                <div class="logo">
                </div>
            </div>
            <div class="main _image-right">
                <div class="image">
                    <img src="/images/marketing-seo-and-ppc-header.jpg">
                </div>
                <div class="content">
                    <div>
                        <p class="mt-0">
                            copy needed
                        </p>
                        <div class="footer">
                            <div class="enquiry-button" v-if="!logged_in_user.isStaff">
                                <div class="btn-primary" @click.stop="enquiry_box_open = true">
                                    Make Enquiry
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">SEO & PPC Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some advice on improving the SEO on my website.',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 7,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'SEO enquiry',
                'value': 'SEO enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been submitted, you will be sent a notification when you receive a reply.'
                });
            });
        },
    },
};
</script>
